// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"761e8965","89":"8ef1f5e7","314":"499a092c","396":"45f53e29","764":"12ace87f"}[chunkId] + ".css";
};